import { ArrowLeft, Home } from 'lucide-react';
import { Button } from '@src/design-system/button';
import { UnauthorizedSvg } from './unauthorized-svg';
import { useLocation, useNavigate } from 'react-router-dom';
import { formatTextForDisplay } from '@shared/utils/helpers/format-text-for-display';
import { createRoute, PATHS } from '@src/core/router/paths';

export function UnauthorizedComponent({ codeName }: { codeName?: string }) {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleHomepage = () => {
    navigate(createRoute(PATHS.DASHBOARDS));
  };

  return (
    <>
      <div className='flex flex-col items-center justify-center'>
        <div className='text-center flex flex-col items-center justify-center mb-2'>
          <UnauthorizedSvg />

          <h2 className='text-2xl mt-2 font-medium! text-gray-800'>
            Access Denied
          </h2>

          <p className='text-lg text-gray-800'>
            You don't have permission to access this page.
          </p>
        </div>

        {codeName && (
          <div className='text-xs text-gray-900 font-medium bg-white py-3 px-4 rounded-lg border border-pale-border mb-8'>
            You need access to <strong>{formatTextForDisplay(codeName)}</strong>
          </div>
        )}

        {/* Action Buttons */}
        <div className='flex flex-col sm:flex-row gap-3'>
          <Button
            onClick={handleGoBack}
            variant='primaryOutline'
          >
            <ArrowLeft className='w-4 h-4 group-hover:-translate-x-1 transition-transform duration-200' />
            <span>Go Back</span>
          </Button>

          <Button onClick={handleHomepage}>
            <Home />
            <span>Homepage</span>
          </Button>
        </div>
      </div>
    </>
  );
}

export function Unauthorized() {
  const { state } = useLocation();
  const codeName = state?.codeName;

  return (
    <div className='min-h-screen bg-primary-50 flex flex-col items-center justify-center px-4'>
      <UnauthorizedComponent codeName={codeName} />
    </div>
  );
}
